import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initDensity } from './hooks/useDensity';
import './styles/index.css';

initDensity();

// Create React Query client with sensible defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Detect basename from actual URL for multi-domain support:
// - conhecendotudo.online/bolao2026/* → basename: /bolao2026
// - bolao2026.net/* → basename: / (empty)
function detectBasename(): string {
  const path = window.location.pathname;
  if (path.startsWith('/bolao2026')) {
    return '/bolao2026';
  }
  return '';
}
const basename = detectBasename();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
